/**
 * Phase 18.17 Batch 5 — Hubs page.
 *
 * Combines the new CMS-driven ExtraPageBanner with a live CRM-managed
 * hubs list (HubsLiveList) and the CMS-managed CTA-band. The existing
 * CMS hero block is filtered via `hideBlockTypes={["hero"]}` and
 * marked "Vervangen" in the backoffice; any other CMS content blocks
 * (info-notes, FAQ, etc.) continue to render between the live list
 * and the CTA-band.
 */
import React from "react";
import SEO from "../components/SEO";
import CmsPageRenderer from "../components/CmsPageRenderer";
import ExtraPageBanner from "../components/ExtraPageBanner";
import HubsLiveList from "../components/HubsLiveList";
import { ToolPageCtaBand } from "../components/ToolPageCms";
import RelatedDestinations from "../components/RelatedDestinations";
import useExtraPageCms from "../hooks/useExtraPageCms";
import { useI18n } from "../context/I18nContext";

export default function HubsPage() {
  const { t } = useI18n();
  const { data } = useExtraPageCms("hubs", null);
  return (
    <>
      <SEO
        title={t("hubs.seo_title")}
        description={t("hubs.seo_description")}
        keywords={t("hubs.seo_keywords")}
      />
      <CmsPageRenderer
        slug="hubs"
        testid="hubs-cms-driven"
        hideBlockTypes={["hero"]}
        topSection={<ExtraPageBanner slug="hubs" />}
        extraSections={
          <>
            <HubsLiveList />
            <ToolPageCtaBand cta={data?.cta_band} testid="hubs-cta-band" />
            <RelatedDestinations
              testid="hubs-related"
              eyebrow="Hubs en bestemmingen"
              title="Naar welke bestemming verzendt u?"
              description="Onze hubs bedienen meerdere Caribbean-bestemmingen. Bekijk per bestemming wat wij verzorgen."
              anchorTemplate="Verzending naar {name}"
            />
          </>
        }
      />
    </>
  );
}
